export default "/images/cumpleao.jpg?4ee489c93b228225f66cec10364a6f9c";